
































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import DateComponent from "@/components/common/Inputs/Date.vue";
import { State, Action, Getter } from "vuex-class";
import moment from 'moment';

@Component({
    components: {
        DateComponent
    }
})
export default class ReportPeriodEditor extends Vue {
    @Prop() dialog: boolean;
    @Prop() report: any;
    @Action("showNotification", { namespace: 'application' }) notify: any;

    /** validate the end date */
    validateEndDate() {
      if(moment(this.report.EndDate) <= moment(this.report.StartDate)) {
        this.notify({
                    text: 'End date must be greater than the Start date.',
                    isHtml: true,
                    color: "error"
                });
      } else if (moment(this.report.DueDate) < moment(this.report.EndDate)) {
        this.notify({
                    text: 'End date must be less than the Due date.',
                    isHtml: true,
                    color: "error"
                });
      }
    }
    
    /** validate due date */
    validateDueDate() {
      if (moment(this.report.DueDate) < moment(this.report.EndDate)) {
        this.notify({
                    text: 'Due date must be greater than the End date.',
                    isHtml: true,
                    color: "error"
                });
      }
    }
    
}
